<template>
  <div class="p-3 bg-white">
    <shared-add-user
      @registerUserSuccess="registerSuccess"
      :departments="departmentOptions"
      :unused-extensions="unusedExtensionOptions"
    ></shared-add-user>

    <div class="text-center">
      <vs-button id="addUserButton" class="m-2" color="primary" type="filled" @click.prevent="initRegister">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddUser">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import User from '@/models/User'
import SharedAddUser from '@/views/Shared/User/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.User.Add',
  components: {
    SharedAddUser
  },
  data () {
    return {
      userPages: 1,
      departmentOptions: [],
      unusedExtensionOptions: []
    }
  },
  mounted () {
    this.loadUsersList()
  },
  methods: {
    async loadUsersList (page) {
      this.$store.dispatch('setIsMainTableLoading', true)
      // TODO: Create additional API that returns only departments, unusedExtensions
      const response = await User.all({ ...this.usersSearchParams, page })
      this.departmentOptions = response.data.meta.options.departments
      this.unusedExtensionOptions = response.data.meta.options.unusedExtensions
      this.$store.dispatch('setIsMainTableLoading', false)
    },
    initRegister () {
      EventBus.$emit('registerUser')
    },
    registerSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_users_table')
      window.close()
    },
    cancelAddUser () {
      this.$windowOpenerHelper.notifyOpener('reload_users_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
